/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdError} from './error';
import {MdFormField} from './form-field';
import {MdHint} from './hint';
import {MdPlaceholder} from './placeholder';
import {MdPrefix} from './prefix';
import {MdSuffix} from './suffix';
import {CommonModule} from '@angular/common';
import {PlatformModule} from '@angular/material/core';
export class MdFormFieldModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    MdError,
    MdHint,
    MdFormField,
    MdPlaceholder,
    MdPrefix,
    MdSuffix,
  ],
  imports: [
    CommonModule,
    PlatformModule,
  ],
  exports: [
    MdError,
    MdHint,
    MdFormField,
    MdPlaceholder,
    MdPrefix,
    MdSuffix,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdFormFieldModule_tsickle_Closure_declarations() {
/** @type {?} */
MdFormFieldModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdFormFieldModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
